import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-tryher-card-basic.js';

const buttonHtml = buttonPrimary({
  text: 'Start Looking More Rested',
  backgroundColor: '#F5649B',
  color: '#FFFFFF',
  radius: 24,
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div
    data-attribute="tryher-card-basic"
    class="tryher-card-basic container"
    data-image-position="right"
    data-container-full-width="true"
    data-border-color="#000000"
    style="---boder-color: #000000"
  >
    <header
      data-attribute="tryher-card-basic__header"
      class="tryher-card-basic__header"
      data-show="true"
    >
      <h2 style="text-align: center">
        <strong
          >5 Reasons You Still Look Tired (Even When You&rsquo;re Not)</strong
        >
      </h2>
    </header>

    <div
      data-attribute="tryher-card-basic__layout"
      class="tryher-card-basic__layout"
    >
      <div
        data-attribute="tryher-card-basic__content-box"
        class="tryher-card-basic__content-box"
        data-background-color="#FFFFFF"
        data-text-color="#000000"
        style="--content-background-color: #ffffff; --content-text-color: #000000"
      >
        <div
          data-attribute="tryher-card-basic__content"
          class="tryher-card-basic__content"
        >
          <h2>
            <span style="color: hsl(337, 92%, 70%)"
              ><strong
                >1. You Wake Up Looking Fine… Then Catch Yourself In The Mirror
                Later</strong
              ></span
            >
          </h2>
          <p>
            Good lighting hits and suddenly your under-eyes look hollow, your skin
            looks flat, and you look more tired than you feel.
          </p>
          <p>That disconnect is what's been bothering you.</p>
        </div>
        <div
          data-attribute="tryher-card-basic__button"
          class="tryher-card-basic__button"
          data-position="center"
        >
          ${buttonHtml}
        </div>
      </div>

      <div
        data-attribute="tryher-card-basic__media"
        class="tryher-card-basic__media"
      >
        <img
          data-attribute="tryher-card-basic__image"
          src="https://cdn.skyfastimg.com/images/2026/07/22/image-6a6076292db2b7b0887c51a5.webp?w=1000"
          alt="Woman looking in a mirror"
        />
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFF7FC',
  textColor: '#000000',
});
